import { wrapTextChildrenWithTypography } from '@/helpers/typography-wrapper';
import * as NavigationMenu from '@radix-ui/react-navigation-menu';
import { Icon, Typography, space } from '@sunwebgroup/ui-components';
import { styled } from 'styled-components';

export const HeaderLink = styled(NavigationMenu.Link).attrs(({ children }) => ({
  children: wrapTextChildrenWithTypography(children),
}))`
  align-items: center;
  color: inherit;
  display: inline-flex;
  text-decoration: none;

  ${Typography} {
    pointer-events: none;
  }

  ${Icon} {
    margin-right: ${space('primitives_space_4')};
  }
`;
